// reducers/recordReducer.js
//data fetch krwa kr sidha reducer mai rkhwa dia

const initialState = {
  records: [],
};

const recordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_RECORDS':
      return {
        ...state,
        records: action.payload,
      };
      case 'UPDATE_RECORD': // Handle update action
      return {
        ...state,
        records: state.records.map(record =>
          record.id === action.payload.id ? action.payload : record
        ),
      };
      case 'DELETE_RECORD':
        return {
          ...state,
          records: state.records.filter(record => record.id !== action.payload),
        };

    default:
      return state;
  }
};

export default recordsReducer;
